import React from "react";
import {Button, Table} from "antd";

const columns = [
    {
        title: '序号',
        dataIndex: 'code',
        render: text => <span>{text}</span>,
    },
    {
        title: '仓库编号',
        dataIndex: 'name',
        align: 'left',
    },
    {
        title: '仓库名称',
        dataIndex: 'date',
    },
    {
        title: '负责人',
        dataIndex: 'unOutCount',
    },
    {
        title: '电话',
        dataIndex: 'status',
    },
    {
        title: '公司',
        dataIndex: 'status',
    },
    {
        title: '地址',
        dataIndex: 'status',
    },
];
const data = [
    {
        key: '1',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '2',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '3',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '4',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '5',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '6',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
];
export default function () {
    const onAdd = () => {
    }
    const onEdit = () => {

    }
    return (
        <>
            <div style={{margin: "0 0 8px", textAlign: "right"}}>
                <Button type="primary" onClick={onAdd}>新增</Button>
                <Button className="margin-left-8" onClick={onEdit}>编辑</Button>
            </div>

            <Table
                columns={columns}
                dataSource={data}
                bordered
                pagination={true}
                rowSelection={{
                    type: "checkbox",
                    onChange: (selectedRowKeys, selectedRows) => {
                        // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled',
                        name: record.name,
                    }),
                }}
                scroll={{x: 'max-content'}}
            />
        </>
    )
}